import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { DatastoreService } from './datastore.service';

import * as moment from 'moment';
import { BehaviorSubject, Observable, Subject, Subscription, timer } from 'rxjs';
import { ModalService } from '../components/modal';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ConfigService } from './config.service';


@Injectable({
  providedIn: 'root'
})
export class CommonFunctionsService {


  public journeyData: BehaviorSubject<any>;
  public subscription!: Subscription;
  public everySecondTimer: Observable<any> = timer(0, 1000);
  private userLoggedIn = new Subject<boolean>();
  private config = new Subject<any>();
  private location = new Subject<any>();
  private meetingRoom = new Subject<boolean>();
  private cardScanInput = new Subject<any>();
  private siteLoaded: string = "";
  private compLoaded: string = "";
  private requestError: Subject<any> | null = new Subject<any>();

  constructor(
    private apiService: ApiService,
    private dataStore: DatastoreService,
    private modalService: ModalService,
    private configService: ConfigService,
    private router: Router) {
    this.journeyData = new BehaviorSubject({});
    this.userLoggedIn.next(false);
  }

  setConfig(config: any) {
    this.config.next(config);
  }

  getConfig(): Observable<any> {
    return this.config.asObservable();
  }

  async setCompanyName(params: any) {
    console.log(params)
    if (params.site && params.comp) {
      console.log(this.siteLoaded,params.site)
      // if (this.siteLoaded !== params.site || this.compLoaded !== params.comp) {
        this.siteLoaded = params.site;
        this.compLoaded = params.comp;
        environment.companyName = params.site;
        let token: any = {}
        try {
          token = await this.configService.getToken(this.siteLoaded, this.compLoaded);
        } catch (err) {
          console.log(err)
        }
        // let configs: any = await this.configService.getConfigs()
        // console.log(configs)
        console.log(token.client, this.siteLoaded + ":" + this.compLoaded)
        if (token.client === this.siteLoaded + ":" + this.compLoaded && token.token) {
          environment.companyName = this.siteLoaded
          environment.companyId = parseInt(this.compLoaded)
          environment.clientToken = token.token;
          console.log(environment.companyName, environment.companyId, environment.clientToken, "loaded")
          console.log(this.dataStore.newrelic);
          this.dataStore.newrelic?.noticeError("TEST");
          this.dataStore.newrelic!.setCustomAttribute('client', environment.companyName);
          this.dataStore.newrelic!.setCustomAttribute('company', environment.companyId);

        } else {
          console.log("failed to load site")
          this.router.navigate([`/${params.site}/${params.comp}/404`])

        }
        let config: any = await this.configService.getConfig();
        console.log("config geot", config)
        let companyConfig = JSON.stringify(config);
        environment.jrni = config.host;
        if (config.checkinTypes === undefined)
          companyConfig = "fail"

        this.setConfig(companyConfig);
        this.dataStore.config = companyConfig
        return config
      // }
    } else {
      this.router.navigate(["/404"])
    }
    return false
  }

  getCompanyName() {
    return environment.companyName
  }

  getCompanyId() {
    return environment.companyId
  }

  setLocation(location: any) {
    this.location.next(location);
  }

  getLocation(): Observable<any> {
    return this.location.asObservable();
  }

  setMeetingRoom(meetingRoom: boolean) {
    this.meetingRoom.next(meetingRoom);
  }

  getMeetingRoom() {
    return this.meetingRoom.asObservable();
  }

  setUserLoggedIn(userLoggedIn: boolean) {
    this.userLoggedIn.next(userLoggedIn);
  }

  getUserLoggedIn(): Observable<boolean> {
    return this.userLoggedIn.asObservable();
  }

  setJourneyData(data: any) {
    this.journeyData.next(data);
  }

  setCardScanInput(data: any) {
    this.cardScanInput.next(data);
  }

  getCardScanInput(): Observable<any> {
    return this.cardScanInput.asObservable();
  }

  async getBookings(company_id: number, date: string, hours: any, config: any, refresh = false) {
    let bookings: any = [];
    if (this.dataStore.bookings && !refresh) {
      bookings = this.dataStore.bookings
    } else {
      bookings = await this.apiService.getBookingsCacheForDay(company_id, date, hours);
      if (bookings.err !== undefined) {
        console.log(bookings.err)
        bookings = {
          bookings: [],
          services: []
        }
      }
      const services = bookings.services;
      bookings = bookings.bookings
      this.dataStore.limits = {}
      for (let booking of bookings) {
        let limits: any = {}
        if (config.wasteLimits) {
          const overBookingLimitQuestion = this.getDataForTable(booking, { data: ["answers_summary", { filterKey: "question_id", filterValue: config.wasteLimits.overBookingLimitQuestion }] })
          const overWeightLimitQuestion = this.getDataForTable(booking, { test: true, data: ["answers_summary", { filterKey: "question_id", filterValue: config.wasteLimits.overWeightLimitQuestion }] })
          if (overBookingLimitQuestion) {
            if (overBookingLimitQuestion.answer === "1" || overBookingLimitQuestion.answer === 'true' || overBookingLimitQuestion.answer === true) {

              limits["overBookingLimitQuestion"] = true;
            }
          }
          if (overWeightLimitQuestion) {
            if (overWeightLimitQuestion.answer === "1" || overWeightLimitQuestion.answer === 'true' || overWeightLimitQuestion.answer === true) {
              limits["overWeightLimitQuestion"] = true;
            }
          }
        }

        // if (limits["overWeightLimitQuestion"] === true || limits["overBookingLimitQuestion"] === true) {
        //   const wasteLimit: any = await this.apiService.getWasteLimit(this.dataStore.company, booking.answers_summary.filter((x: { question_id: { toString: () => any; }; }) => x.question_id.toString() === config.wasteLimits.addressQuestionId.toString())[0].answer, moment(booking.datetime).format("DD-MM-YYYY"),moment(booking.datetime).format("HH:mm"))
        //   for (const key in wasteLimit) {
        //     if (wasteLimit.hasOwnProperty(key)) {
        //       const obj = wasteLimit[key];
        //       // Check if the object has a "limit" property
        //       if (obj.hasOwnProperty("limit")) {
        //         // Calculate the "overLimit" property
        //         obj.overLimit = Math.max(0, obj.amount - obj.limit);
        //       }
        //     }
        //   }
        //   limits["wasteLimit"] = wasteLimit
        // }
        // this.dataStore.limits[booking.id] = limits
      }
      this.dataStore.bookings = bookings
      const servicesObj: any = {}
      console.log(services)
      console.log(this.dataStore.bookings)
      for (let service of services) {
        // service.bookingQuestions = await this.apiService.questions(service);
        if (service.questions?.questions) {
          service.bookingQuestions = service.questions.questions
        }
        else {
          service.bookingQuestions = [];
        }
        servicesObj[service.id] = service
      }
      this.dataStore.services = servicesObj;
    }
    this.dataStore.tabBookingsCounts = {}
    for (let status in config.customizable) {
      const statusMulti = this.statusConverterMulti(status);
      if (config.customizable[status].overrideShowAllExcept) {
        this.dataStore.tabBookingsCounts[status] = bookings.filter((x: { current_multi_status: string; }) => {
          return config.customizable[status].overrideShowAllExcept.filter((y: string) => {
            return x.current_multi_status?.toString() === y || (x.current_multi_status === undefined && y === "")
          }).length === 0
        }).length
      } else {
        this.dataStore.tabBookingsCounts[status] = bookings.filter((x: { current_multi_status: string; }) => {
          return x.current_multi_status?.toString() === status.toString() || x.current_multi_status?.toString() === statusMulti || (statusMulti === "" && x.current_multi_status === undefined)
        }).length
      }

    }
    // let noBookings: any = await this.apiService.getNoBookings(this.dataStore.loginObject.member.company_id, moment().locale('en').format('YYYY-MM-DD'), config.staging)
    // this.dataStore.tabNoBookingCount = noBookings.length
    return bookings;
  }

  statusConverterMulti(status: string) {
    status = status === "confirmed" ? "" : status
    status = status === "noShow" ? "no_show" : status
    status = status === "rejected" ? "rejected" : status
    status = status === "arrived_and_paid" ? "arrived_and_paid" : status
    status = status === "arrived" ? "checked_in" : status
    return status
  }


  getDataForTable(data: any, tab: any) {
    const keyArray = tab.data
    let out = data;
    for (let key of keyArray) {
      if (out !== undefined) {
        if (key.filterKey) {
          out = out.filter((x: { [x: string]: { toString: () => any; }; }) => x[key.filterKey].toString() === key.filterValue.toString())[0]
        } else {
          out = out[key]
        }
      }
    }
    if (tab.format === "date") {
      out = moment(out).format("DD/MM/YYYY")
    }
    if (tab.format === "time") {
      out = moment(out).format("HH:mm")
    }
    if (out === undefined) {
      out = "-"
    }
    return out;
  }

  updateLocalBookingsCache(booking: any) {
    console.log("updateLocalBookingsCache")
    const bookingsWithout = this.dataStore.bookings.filter((x: { id: any; }) => x.id !== booking.id)
    console.log(bookingsWithout)

    bookingsWithout.push(booking)
    this.dataStore.bookings = bookingsWithout
    console.log(this.dataStore.bookings)

  }

  async bookingCancel(id: any) {
    const res: any = await this.apiService.bookingCancel(this.dataStore.company.id, id, true, "No show");
    return res;
  }

  async patchMember(member: any) {
    const res: any = await this.apiService.patchMember(this.dataStore.company.id, member.id, member);
    return res;//.bookings;
  }

  async getPastBookings() {
    const bookings: any = await this.apiService.getPastBookings(this.dataStore.company.id, this.dataStore.member.id);
    return bookings["_embedded"].bookings;
  }

  async getBookingsAttendees(company_id: number, id: number) {
    const attendees: any = await this.apiService.getBookingsAttendees(this.dataStore.company, this.dataStore.member.id, id);
    return attendees["_embedded"].attendees;//.bookings;
  }

  getResource(resourceId: any) {
    let resource = "";
    this.dataStore.resources.forEach((element: { resource_id: any; name: any; }) => {
      if (element.resource_id === parseInt(resourceId)) {
        resource = element.name;
        return;
      }
    });

    return resource;
  }

  getParent(company: any) {
    let parentComp = "";

    this.dataStore.companies.forEach((element: { id: any; parent: any; }) => {
      if (element.id === parseInt(company)) {
        parentComp = element.parent;
        return;
      }
    });

    return parentComp;
  }

  getBuilding(company: any) {
    if (!this.dataStore.companies) {
      return;
    }

    const parentComp = this.getParent(company);

    let building = "";

    this.dataStore.companies.forEach((element: { id: any; name: any; }) => {
      if (element.id === parseInt(parentComp)) {
        building = element.name;
        return;
      }
    });

    return building;
  }

  async checkinBooking(company: any, bookingId: any) {
    await this.apiService.putCheckinBooking(company, this.dataStore.member.id, bookingId);
  }

  async checkoutBooking(company: any, bookingId: any) {
    await this.apiService.getCheckoutBooking(company, this.dataStore.member.id, bookingId);
  }

  async amendBooking(booking: any, date: any, time: any, duration: any) {
    return await this.apiService.moveBooking(booking, date, time, duration);
  }

  async cancelBooking(company: any, bookingId: any) {
    await this.apiService.getCancelBooking(company, this.dataStore.member.id, bookingId);
  }

  disableAction(booking: any, action: string) {
    const service = booking.service_name;
    const timeLimits = this.dataStore.timeLimits;
    const configObj: any = sessionStorage.getItem('config');
    const config: any = JSON.parse(configObj);
    let limit: any;

    const bookingStartTime = moment(booking.datetime);
    const bookingEndTime = moment(booking.end_datetime);

    timeLimits.forEach((timeLimit: any) => {
      if (service === timeLimit.name) {
        limit = timeLimit.limit;
      }
    });

    const bookingChangeLimit = moment(booking.datetime).subtract('minutes', limit);

    const currentTime = moment();

    if (action === 'checkin') {

      const configServiceName = service.toLowerCase().replaceAll(" ", "_").trim();
      const minTime = config.checkinRules[configServiceName]?.min_checkin_time;
      const maxTime = config.checkinRules[configServiceName]?.max_checkin_time;

      const checkinStart = moment(booking.datetime);
      const checkinEnd = moment(booking.datetime);
      const checkinStartTime = checkinStart.subtract(minTime, 'minutes').format();
      const checkinEndTime = checkinEnd.add(maxTime, 'minutes').format();
      if (currentTime.isBefore(checkinStartTime)) {
        return true;
      }
      if (currentTime.isAfter(checkinEndTime)) {
        return true;
      }

      return false;
    }

    if (action === 'amend') {

      const configServiceName = service.toLowerCase().replaceAll(" ", "_").trim();
      const minTime = config.bookingRules[configServiceName]?.min_amend_time;

      if (currentTime.isAfter(bookingStartTime)) {
        return true;
      }

      return false;
    }

    if (action === "cancel") {
      if (currentTime.isAfter(bookingChangeLimit)) {
        return true;
      }
    }


    return false;
  }

  isLoggedIn() {
    if (localStorage.getItem('auth_token') && localStorage.getItem('member')) {
      return true;
    }

    return false;
  }

  bookingStage(stage: any) {

    if (this.dataStore.bookingDetails?.serviceId === "") {
      return "service";
    }

    switch (stage) {
      case "find":
        return "";
      case "addon":
        if (this.dataStore.bookingDetails?.childCompanyId === ""
          || this.dataStore.bookingDetails?.parentCompanyId === ""
          || this.dataStore.bookingDetails?.resourceId === "") {
          return "find";
        }
        return "";
      case "summary":
        if (this.dataStore.bookingDetails?.childCompanyId === ""
          || this.dataStore.bookingDetails?.parentCompanyId === ""
          || this.dataStore.bookingDetails?.resourceId === "") {
          return "find";
        }
        if (this.dataStore.bookingDetails?.addon === "") {
          return "addon";
        }
        return "";
      default:
        break;
    }
    return 'access';
  }

  newBooking() {
    this.dataStore.bookingDetails = {
      serviceId: "",
      childCompanyId: "",
      parentCompanyId: "",
      resourceId: "",
      resourceName: "",
      event_id: "",
      time: "",
      date: "",
      addon: "",
      attendees: [],
      bookingId: "",
      res: ""
    }
    this.dataStore.serviceItem = "";
    this.dataStore.checkout = "";
    this.dataStore.basket = null;
    this.dataStore.basketEndTime = null;
    this.dataStore.timer = false;
    this.dataStore.multi = false;
    this.dataStore.extraBookings = [];
  }

  async formatQuestions(questions: any) {
    var questionKeys = Object.keys(questions).map((key) => [Number(key), questions[key]]);

    const basketQuestions = [];

    for (const question of questionKeys) {

      if (!isNaN(question[0]) && question[1]) {
        basketQuestions.push({
          id: question[0], answer: question[1]
        });
      }
    }

    return basketQuestions;
  }

  getEndTime(booking: any) {
    const endTime = moment(booking.datetime).add(booking.duration, 'seconds');
    return endTime.format();
  }

  searchQuestion(id: any) {
    const config = sessionStorage.getItem('config');
    if (config) {
      const configJson = JSON.parse(config);
      const serviceId = this.dataStore.bookingDetails.serviceId;
      if (configJson.searchFields.service[`${serviceId}`]?.id === String(id)) {
        return true;
      } else {
        return false;
      }
    }

    return false;
  }

  isKiosk(): boolean {
    // const host = window.location.host;
    // if (host != "localhost:4200" && host != "localhost:4201") {
    //   const path = window.location.pathname;
    //   if (path.indexOf("kiosk") === -1) {
    //     return false;
    //   }
    // }

    const configObj: any = sessionStorage.getItem("config");
    const config: any = JSON.parse(configObj);
    const kioskAvailable = config?.kiosk;

    if (sessionStorage.getItem("kiosk")) {
      const kioskObj: any = sessionStorage.getItem("kiosk");
      const kiosk = JSON.parse(kioskObj);

      const configObj: any = sessionStorage.getItem("config");
      const config: any = JSON.parse(configObj);
      const kioskAvailable = config?.kiosk;

      if (kioskAvailable && kiosk === "true") {
        return true;
      }
    }

    return false;
  }

  isMeetingRoom(): boolean {
    const path = window.location.pathname;

    if (path.indexOf("meeting-room") === -1) {
      return false;
    }

    const configObj: any = sessionStorage.getItem("config");
    const config: any = JSON.parse(configObj);
    const meetingRoomAvailable = config?.meeting_room;

    if (meetingRoomAvailable) {
      return true;
    }

    if (sessionStorage.getItem("meetingRoom")) {
      const meetingRoomObj: any = sessionStorage.getItem("meetingRoom");
      const meetingRoom = JSON.parse(meetingRoomObj);

      const configObj: any = sessionStorage.getItem("config");
      const config: any = JSON.parse(configObj);
      const meetingRoomAvailable = config?.meeting_room;

      if (meetingRoomAvailable && meetingRoom === "true") {
        return true;
      }

      sessionStorage.setItem("meetingRoom", JSON.stringify("false"));
      this.setMeetingRoom(false);

    }

    return false;
  }

  signOut() {
    const config = sessionStorage.getItem('config') as string;
    const configObj = JSON.parse(config) as any;
    const canUseSSO = (configObj.hasOwnProperty('sso')) ? configObj.sso : false;

    if (canUseSSO) {
      this.ssoLogout();
    } else {
      this.logout()
    }
  }

  logout() {
    localStorage.clear();
    this.dataStore.authToken = null;
    this.dataStore.member = null;
    this.dataStore.member = null;
    this.dataStore.loginObject = null;
    this.dataStore.loggedIn = false;
    this.newBooking();
    const splitHref = window.location.href.split("/")
    const params = { site: splitHref[3], comp: splitHref[4] }
    this.router.navigate([`/${params.site}/${params.comp}/login`])

  }

  ssoLogout() { // Add log out function here
    let url = '/';
    const host = window.location.host;
    if (host === "localhost:4200" || host === "localhost:4201" || host === "staging.bookinglab.co.uk" || host === "bookings.bookinglab.co.uk") {
      const pathname = window.location.pathname;
      var split = pathname.split("/");
      var company = split[1].split("-desk-room-bookings");
      var companyName = company[0];

      if (host === "staging.bookinglab.co.uk") {
        url = split[1];
      }
      if (host === "localhost:4201" || host === "localhost:4200") {
        url = '/';
      }
      else {
        url = `https://${host}/${split[1]}` as string;
      }

    }

    localStorage.clear();
    this.dataStore.authToken = null;
    this.dataStore.member = null;
    this.dataStore.loggedIn = false;
    this.newBooking();

    // this.authService.logoutRedirect({
    //   postLogoutRedirectUri: `${url}`
    // });
  }

  kioskLocation() {
    const location = sessionStorage.getItem("location") as any;
    const locationObj = JSON.parse(location) as any;

    const building = locationObj.building;

    return building;
  }

  openModal(id: string) {
    this.modalService.open(id);
  }

  closeModal(id: string) {
    this.modalService.close(id);
  }

  scrollToTop() {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 10);
  }

  setRequestError(error: any) {
    this.requestError?.next(error);
  }

  getRequestError(): Observable<any> {
    return this.requestError!.asObservable();
  }

  resetConnectionError() {
    this.requestError = null;
  }

  fontChecker() {
    const fonters = document.getElementsByClassName("fonter") // ever bit of text has this class
    for (let i in fonters) {
      const fonter: any = fonters[i]
      if (fonter.parentElement !== undefined) {
        this.fontUpdate(fonter)
      }
    }
  }

  fontUpdate(fonter: any) {
    // check if the text's span is larger than the div/button/etc. 
    // if it is then   we reduce the font size a bit, and check if it now fits
    // if not shrink and check again, and so on till it fits
    // (we add 10% of the parent's size to the child's to ensure the last letter is not clipping through the side of the parent)
    if (fonter.getBoundingClientRect().width + (fonter.parentElement.getBoundingClientRect().width * 0.1) > fonter.parentElement.getBoundingClientRect().width) {
      const newFontSize = parseInt(window.getComputedStyle(fonter, null).getPropertyValue('font-size').replace("px", "")) - 2;
      console.log("newFontSize", newFontSize)
      fonter.style.fontSize = newFontSize + "px"
      this.fontUpdate(fonter)
    }
  }

  async noShowAll(bookings: any[]) {
    for (let booking of bookings) {
      await this.apiService.updateStatus(booking.booking.company_id, booking.booking.id, "no_show")
      if (booking.booking?.settings) {
        booking.booking.settings.current_multi_stat = status
      } else {
        booking.booking.settings = { "current_multi_stat": status }
      }
      this.updateLocalBookingsCache(booking.booking)
    }
  }

  
  checkBoxGroupsCheck(config: any, controls: any, page: string) {
    let allAtLeastOne = true;
    const errorFields = []
    for (let group of config.myCeremony.checkboxGroups) {
      let groupAtLeastOne = false;
      let groupAllDisabled = true;
      if (group.page === page) {
        for (let box of group.group) {
          // console.log(controls[box])
          if (controls[box].value === true) {
            groupAtLeastOne = true
          }
          if (controls[box].status !== "DISABLED") {
            groupAllDisabled = false
          }
        }
        if (!groupAtLeastOne && !groupAllDisabled) {
          allAtLeastOne = false
          errorFields.push(group.group[0])
        }
      }
    }
    return {allAtLeastOne:allAtLeastOne,errorFields:errorFields};
  }
}